import axios from 'axios';
import { createAction } from 'redux-action';
import { get_service_endpoint } from '../../ServiceEndpoints.js';
import { postEvent, showModal } from './AssessmentActions';
import { AssessmentStatus } from '../../store/reducers/InviteReducer';

//let ep = get_service_endpoint("cs-auth");

// let ep = "http://127.0.0.1:8000";

const errorType = '404';

let fsep = get_service_endpoint('cs-fileupload');

export const AxiosCallRequest = createAction('AXIOS_CALL_REQUEST');

export const AxiosCallError = createAction('AXIOS_CALL_ERROR');

export const AxiosCallSuccess = createAction('AXIOS_CALL_SUCCESS');

export const onLoadModal = createAction('ON_LOAD_MODAL');

export const requestApi = createAction('REQUEST_API');

export const onToggleAuthModal = createAction('ON_TOGGLE_AUTH_MODAL');

export const onLocationChange = createAction('@@react-router/LOCATION_CHANGE');

export const Download = createAction('DOWNLOAD');

export const resetEntityTypeAndID = createAction('RESET_ENTITY_TYPE_AND_ID');

export const showErrorPage = createAction('SHOW_ERROR_PAGE');

export const setCurrentPage = createAction('SET_CURRENT_PAGE');

export const WSConnected = createAction('WEBSOCKET_CONNECTED');

export const WSDisconnected = createAction('WEBSOCKET_DISCONNECTED');

export const deleteFileFromServer = payload => {
  return () => {
    axios.delete(`${fsep}/api/files/${payload.fileId}/`);
  };
};

export const attemptToDownloadFile = payload => dispatch =>
  dispatch(Download({ type: 'DOWNLOAD_ATTEMPT', data: payload }));

export const downloadFile = payload => dispatch =>
  dispatch(Download({ type: 'DOWNLOAD_SUCCESS', data: payload }));

export const pageNotFound = createAction('PAGE_NOT_FOUND');

export const resetPageNotFound = () => {
  return dispatch => {
    dispatch(pageNotFound(false));
  };
};

export const setPageNotFound = (errorHeading, errorMessage) => {
  return dispatch => {
    dispatch(
      pageNotFound({
        pageNotFound: true,
        errorHeading,
        errorMessage,
        errorType,
      }),
    );
  };
};

export const documentLostFocus = () => {
  return (dispatch, getState) => {
    let assessment_status = getState().invite.assessment_status;
    let test_settings = getState().assessment.test_settings;

    // Only show modal after media sharing is completed
    const mediaShareCompleted = getState().assesmentRecording.mediaShareCompleted;
    if (!mediaShareCompleted && test_settings.enable_screen_and_camera) return;

    if (assessment_status === AssessmentStatus.InProgress) {
      dispatch(
        showModal({
          name: 'document_lost_focus',
          type: 'warning',
          title: 'You’ve navigated away from the test',
          content:
            'Please return to the test window to continue.This has been recorded on your assessment, please do not perform any of these actions again as it may result in disqualification.',
          onOk: () => {},
        }),
      );
      let data = {
        type: 'NAVIGATED_AWAY',
        subtype: 'TAB_SWITCH',
      };
      let current_page = getState().events.current_page;
      let curr_problem_id;
      if (current_page === 'QP')
        curr_problem_id = getState().assessment.problems.find(p => p.isCurrent === true).id;
      if (curr_problem_id) {
        data['data'] = {
          page: current_page,
          prob_id: curr_problem_id,
        };
      } else {
        data['data'] = {
          page: current_page,
        };
      }
      //prevents tab switch event from firing if the event was for tab close or page reload
      if (!sessionStorage.getItem('tab_closed')) dispatch(postEvent(data));
    }
  };
};

export const tabClose = () => {
  return (dispatch, getState) => {
    let data = {
      type: 'NAVIGATED_AWAY',
      subtype: 'CLOSE',
    };
    if (getState().invite.assessment_status === AssessmentStatus.InProgress)
      dispatch(postEvent(data));
  };
};

export const refreshTab = () => {
  return (dispatch, getState) => {
    let data = {
      type: 'NAVIGATED_AWAY',
      subtype: 'RELOAD',
    };
    if (getState().invite.assessment_status === AssessmentStatus.InProgress)
      dispatch(postEvent(data));
  };
};
